// Widget Scripts
import ticketButton from './js/widgets/ticketButton.js';
import slideshow from './js/widgets/slideshow.js';
import autoEvent from './js/widgets/autoEvent.js';
import cardWidget from './js/widgets/cardWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';
import './js/subpages/local-subpages.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  ticketButton();
  if (globalThis.location.pathname === '/') {
    slideshow();
    autoEvent();
    cardWidget('cardWidgetRectangular', cardWidgetRectangularOpts);
    seoWidget();
    cardWidget('cardWidgetCircular', cardWidgetCircularOpts);
    scrollerSponsors();
    $(globalThis).load(function () {
      videoWidget();
    });
  }
});
